import { render, staticRenderFns } from "./ShopContentSwitch.vue?vue&type=template&id=973fb9f8"
import script from "./ShopContentSwitch.vue?vue&type=script&lang=ts"
export * from "./ShopContentSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ShopContentSwitch.vue?vue&type=style&index=0&id=973fb9f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports